import io from 'socket.io-client';
import { BACKEND } from './clientConstants';
const SOCKET_URL = BACKEND + "/";
//export const exitSocket = io.of('/exitroute');
export const socket = io(SOCKET_URL); 